import { render, staticRenderFns } from "./ConfirmAutoLogin.vue?vue&type=template&id=6484757a&scoped=true&"
import script from "./ConfirmAutoLogin.vue?vue&type=script&lang=js&"
export * from "./ConfirmAutoLogin.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAutoLogin.vue?vue&type=style&index=0&id=6484757a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6484757a",
  null
  
)

export default component.exports